import React from "react";
import Navbar from "../components/FrontPages/Common/Navbar";
import ContactUs from "../components/FrontPages/Common/ContactUs";
import Footer from "../components/FrontPages/Common/Footer";
import PageBanner from "../components/FrontPages/Common/PageBanner";
import FaqContent from "../components/FrontPages/Common/FaqContent";

const Contact = () => {
  return (
    <>
      <div className="fp-wrapper">
        <Navbar />
        <PageBanner pageTitle="Contact Us" />
        <ContactUs />
        <FaqContent />

        <Footer />
      </div>
    </>
  );
};

export default Contact;
